// gtag.js
export const gtag = window.gtag || function() {
    (window.dataLayer = window.dataLayer || []).push(arguments);
  };
  
  gtag('js', new Date());
  gtag('config', 'G-TS8NP4J8Z6'); // Replace with your GA4 Measurement ID


